import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/soluciones/tecnologia-aprendizaje/")({
  beforeLoad: () => {
    throw redirect({ to: "/soluciones/tecnologia-aprendizaje/athena-lms" });
  },
});
